<template>
  <div v-loading="holeLoading" class="h-full w-full">
    <!-- <el-button type="primary"
      size="small"
      class="mxgrapgTopBtn"
    @click="backToDrawList">返回绘图列表</el-button>-->
    <iframe
      :src="mxgraphFramePath"
      class="w-full h-full"
      ref="mxgraphframe"
      id="mxgraphframe"
      title="mxgraph"
      @load="getStartDraw"
    ></iframe>
    <el-dialog
      v-dialogDrag
      title="编辑类别"
      :visible.sync="dialogVisible"
      width="1200px"
      :close-on-press-escape="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="类别信息" class="w-full" name="type" :disabled="ifTypeDisable">
          <el-form
            label-width="100px"
            ref="typeInfo"
            :rules="classFormRules"
            :model="typeInfo"
            label-position="left"
          >
            <el-row :gutter="20" class="pl-10px pr-20px">
              <el-col :span="12">
                <el-form-item label="类别代码:" prop="code" class="w-full">
                  <el-input
                    size="small"
                    v-model.trim="typeInfo.code"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="类别名称:" prop="name" class="w-full">
                  <el-input
                    size="small"
                    v-model.trim="typeInfo.name"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上级类别:" prop="parentId">
                  <el-select
                    v-model="typeInfo.parentId"
                    clearable
                    filterable
                    class="w-full"
                    placeholder="请选择"
                    size="small"
                    :disabled="typeInfo.isType"
                  >
                    <el-option
                      v-for="item in _.filter(parentTypeList, (item) => {
                        return item.id !== currentClassRowId
                      })"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="序号:" prop="tableName">
                  <el-input
                    size="small"
                    class="w-full"
                    clearable
                    v-model.trim="typeInfo.seqNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否是类型" prop="isType">
                  <div class="flex">
                    <el-checkbox
                      v-model="typeInfo.isType"
                      class="!mr-10px"
                      @change="changeIsType"
                    ></el-checkbox>
                    <el-select
                      :disabled="typeInfo.isType"
                      v-model="typeInfo.stdClassTypeAttributeCateId"
                      placeholder="请选择业务类型"
                      class="flex-1"
                      size="small"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="item in classTypeAttributeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否主数据" prop="isMainData">
                  <div class="flex">
                    <el-checkbox
                      v-model="typeInfo.isMainData"
                      class="!mr-10px"
                      @change="changeIsMainData"
                    ></el-checkbox>
                    <el-select
                      size="small"
                      :disabled="!typeInfo.isMainData"
                      clearable
                      filterable
                      v-model="typeInfo.dataMainTypeId"
                      placeholder="请选择主数据类型"
                      class="flex-1"
                    >
                      <el-option
                        v-for="(item, index) in mainDataTypeList"
                        :key="index"
                        :label="item.typeName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="标签" prop="classLabelIds">
                  <el-select
                    v-model="typeInfo.classLabelIds"
                    :placeholder="`${$t('pleaseSelect')}`"
                    class="w-full"
                    size="small"
                    multiple
                    :multiple-limit="10"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in classLabelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <div v-if="typeInfo.dynamicColumnData.length">
                <el-col
                  :span="12"
                  class="position-relative"
                  v-for="(item, index) in typeInfo.dynamicColumnData"
                  :key="index"
                >
                  <el-form-item :label="item.actualAttributeColumnName" class="w-full">
                    <el-input
                      size="small"
                      clearable
                      v-model="item.value"
                      placeholder="请输入"
                      v-if="item.valueType === 1"
                    ></el-input>
                    <el-select
                      size="small"
                      clearable
                      filterable
                      v-model="item.value"
                      v-if="item.valueType === 5"
                      placeholder="请选择"
                      class="w-full"
                    >
                      <el-option
                        v-for="it in item.actionArr"
                        :key="it.id"
                        :label="it.code"
                        :value="it.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
              <el-col :span="24">
                <el-form-item label="描述" prop="description" class="w-full">
                  <el-input
                    size="small"
                    type="textarea"
                    placeholder="请输入"
                    v-model.trim="typeInfo.description"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="remark" class="w-full">
                  <el-input
                    size="small"
                    v-model.trim="typeInfo.remark"
                    type="textarea"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="属性" name="attribute" :disabled="ifAttributeDisable" class="w-full">
          <div class="tr">
            <el-button @click="addRow()" type="primary">添加行</el-button>
            <el-button @click="deleteRow" type="primary" class="mr-10px !ml-10px"
              >删除数据</el-button
            >
            <el-popover v-model="showPopover" placement="bottom" title="筛选显示列" trigger="click">
              <div class="flex flex-column" style="max-height: 400px; overflow: auto">
                <el-checkbox v-model="showColumnObj.seqNoShow">序号</el-checkbox>
                <el-checkbox v-model="showColumnObj.attributeCodeShow">标准属性代码</el-checkbox>
                <el-checkbox v-model="showColumnObj.codeShow">代码</el-checkbox>
                <el-checkbox v-model="showColumnObj.nameShow">名称</el-checkbox>
                <el-checkbox
                  v-for="item in attrActualColumnArr"
                  :key="item.id"
                  v-model="item.boo"
                  >{{ item.actualAttributeColumnName }}</el-checkbox
                >
                <el-checkbox v-model="showColumnObj.valueTypeShow">数值类型</el-checkbox>
                <el-checkbox v-model="showColumnObj.lengthShow">长度</el-checkbox>
                <el-checkbox v-model="showColumnObj.decimalPointShow">精度</el-checkbox>
                <el-checkbox v-model="showColumnObj.defaultValueShow">默认值</el-checkbox>
                <el-checkbox v-model="showColumnObj.isPrimaryShow">主键属性</el-checkbox>
                <el-checkbox v-model="showColumnObj.isName">名称属性</el-checkbox>
                <el-checkbox v-model="showColumnObj.isTag">标签属性</el-checkbox>
                <el-checkbox v-model="showColumnObj.isNullableShow">非空</el-checkbox>
                <!-- <el-checkbox v-model="showColumnObj.isImportantShow">重要属性</el-checkbox> -->
                <!-- <el-checkbox v-model="showColumnObj.isRuleExpressionShow">是否规则属性</el-checkbox> -->
                <!-- <el-checkbox v-model="showColumnObj.ruleExpressionShow">规则表达式</el-checkbox> -->
                <el-checkbox v-model="showColumnObj.referenceClassAttributeIdShow"
                  >引用属性</el-checkbox
                >
                <el-checkbox v-model="showColumnObj.displayReferenceClassAttributeIdShow"
                  >引用显示属性</el-checkbox
                >
                <!-- <el-checkbox v-model="showColumnObj.className">
                  引用实体
                </el-checkbox>
                <el-checkbox v-model="showColumnObj.className2">
                  继承实体
                </el-checkbox>-->
                <el-checkbox v-model="showColumnObj.unitNameShow">单位</el-checkbox>
                <!-- <el-checkbox v-model="showColumnObj.attributeGroupNameShow">属性分组</el-checkbox> -->
              </div>
              <div class="tc mt-10px">
                <el-button size="mini" @click="showPopover = false">取消</el-button>
                <el-button size="mini" type="primary" @click="refreshColumn">确定</el-button>
              </div>
              <el-button size="small" type="primary" slot="reference">筛选显示列</el-button>
            </el-popover>
          </div>
          <!-- 属性列表的分组 -->
          <vxe-table
            :data="attrData"
            :loading="tableLoading"
            class="w-full mt-20px"
            ref="table"
            border
            :height="tableHeight"
            :scroll-y="{ gt: 20 }"
            @cell-click="rowClick"
            highlight-current-row
            show-overflow
          >
            <vxe-table-column
              type="checkbox"
              width="55"
              align="center"
              class-name="cell-center"
              header-class-name="cell-center"
            ></vxe-table-column>
            <vxe-table-column
              align="center"
              :visible="showColumnObj.seqNoShow"
              title="序号"
              width="85"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.isEdit"
                  clearable
                  @blur="checkData(scope)"
                  size="mini"
                  style="width: 60px"
                  v-model="scope.row.seqNo"
                  placeholder="请输入内容"
                  :controls="false"
                  class="attrtablecolumn"
                ></el-input-number>
                <span v-else>{{ scope.row.seqNo }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="标准属性代码"
              width="150"
              :visible="showColumnObj.attributeCodeShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="scope.row.isEdit"
                  v-model="scope.row.attributeId"
                  filterable
                  clearable
                  :disabled="scope.row.id ? true : false"
                  placeholder="请选择"
                  class="w-full"
                  size="small"
                  @change="changeCode(scope.row.attributeId, scope.row)"
                >
                  <el-option
                    v-for="item in standardAttrList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <span v-else>{{
                  _.get(_.find(standardAttrList, { id: scope.row.attributeId }), 'name')
                }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="代码"
              width="200"
              :visible="showColumnObj.codeShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit"
                  clearable
                  @blur="checkData(scope)"
                  size="small"
                  :disabled="scope.row.sourceType === 1"
                  v-model="scope.row.code"
                  placeholder="请输入内容"
                ></el-input>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="名称"
              width="200"
              :visible="showColumnObj.nameShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit"
                  clearable
                  size="small"
                  :disabled="scope.row.sourceType === 1"
                  v-model="scope.row.name"
                  placeholder="请输入内容"
                  @blur="blurZwmc(scope.row)"
                >
                  <!-- :disabled="disabledAll" -->
                </el-input>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </vxe-table-column>
            <!-- <span > 动态属性列-->
            <vxe-table-column
              v-for="(item, i) in attrActualColumnArr"
              :key="item.id"
              align="center"
              :title="item.actualAttributeColumnName"
              width="150"
              :visible="item.boo"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.isEdit">
                  <el-input
                    size="mini"
                    v-if="ifAttrActualColumn && scope.row.dynamicColumnData[i].valueType === 1"
                    v-model="scope.row.dynamicColumnData[i].value"
                    placeholder="请输入内容"
                    clearable
                  >
                  </el-input>
                  <el-select
                    size="small"
                    clearable
                    filterable
                    v-model="scope.row.dynamicColumnData[i].refValue"
                    v-if="ifAttrActualColumn && scope.row.dynamicColumnData[i].valueType === 5"
                    @change="
                      (val) => {
                        actionChange(scope.row, scope.row.dynamicColumnData[i], val)
                      }
                    "
                    @focus="actionFocus(scope.row.dynamicColumnData[i])"
                    placeholder="请选择"
                    class="w-full"
                  >
                    <el-option
                      v-for="it in scope.row.dynamicColumnData[i].actionArr"
                      :key="it.id"
                      :label="it.name"
                      :value="it.id"
                    >
                      <span
                        v-if="
                          scope.row.dynamicColumnData[i].actualAttributeColumnName === '继承属性'
                        "
                        class="l m-r-10"
                        >{{ it.className }}</span
                      >
                      <span
                        v-if="
                          scope.row.dynamicColumnData[i].actualAttributeColumnName === '继承属性'
                        "
                        class="text-color-grey-ccc fz-14 r"
                        >{{ it.name }}</span
                      >
                    </el-option>
                  </el-select>
                  <div v-else>
                    <span v-if="scope.row.dynamicColumnData[i].valueType === 1">{{
                      scope.row.dynamicColumnData[i].value
                    }}</span>
                    <span v-if="scope.row.dynamicColumnData[i].valueType === 5">{{
                      scope.row.dynamicColumnData[i].refValue
                    }}</span>
                  </div>
                </div>
              </template>
            </vxe-table-column>
            <!-- </span> -->
            <!-- <vxe-table-column
              align="center"
              title="引用实体"
              width="150"
              v-if="showColumnObj.className"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="mini"
                  disabled
                  v-model="scope.row.quoteClassName"
                  placeholder="请输入内容"
                >
                </el-input>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="继承实体"
              width="150"
              v-if="showColumnObj.className2"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="mini"
                  disabled
                  v-model="scope.row.inheritClassName"
                  placeholder="请输入内容"
                >
                </el-input>
              </template>
            </vxe-table-column>-->
            <vxe-table-column
              align="center"
              title="数值类型"
              width="150"
              :visible="showColumnObj.valueTypeShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="scope.row.isEdit"
                  clearable
                  filterable
                  size="small"
                  v-model="scope.row.valueType"
                  @change="scopeSelectChange(scope)"
                  disabled
                >
                  <el-option
                    v-for="item in valueTypeOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span v-else>{{
                  _.get(_.find(valueTypeOptions, { value: scope.row.valueType }), 'name')
                }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="长度"
              width="85"
              :visible="showColumnObj.lengthShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.isEdit"
                  clearable
                  @blur="checkData(scope)"
                  size="small"
                  style="width: 60px"
                  v-model.number="scope.row.length"
                  disabled
                  placeholder="请输入内容"
                  :controls="false"
                  class="attrtablecolumn"
                ></el-input-number>
                <span v-else>{{ scope.row.length }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="精度"
              width="85"
              :visible="showColumnObj.decimalPointShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.row.isEdit"
                  clearable
                  @blur="checkData(scope)"
                  style="width: 60px"
                  size="small"
                  v-model.number="scope.row.decimalPoint"
                  placeholder="请输入内容"
                  class="attrtablecolumn"
                  disabled
                  :controls="false"
                ></el-input-number>
                <span v-else>{{ scope.row.decimalPoint }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="默认值"
              width="150"
              :visible="showColumnObj.defaultValueShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.isEdit"
                  clearable
                  size="small"
                  v-model="scope.row.defaultValue"
                  placeholder="请输入内容"
                  :disabled="scope.row.sourceType === 1"
                ></el-input>
                <span v-else>{{ scope.row.defaultValue }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="主键属性"
              width="80"
              :visible="showColumnObj.isPrimaryShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.isEdit"
                  v-model="scope.row.isPrimary"
                  @change="isprimarychange(scope)"
                  :disabled="scope.row.sourceType === 1"
                ></el-checkbox>
                <span v-else>{{ scope.row.isPrimary ? '是' : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="名称属性"
              width="80"
              :visible="showColumnObj.isName"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.isEdit"
                  v-model="scope.row.isName"
                  :disabled="scope.row.sourceType === 1"
                ></el-checkbox>
                <span v-else>{{ scope.row.isName ? '是' : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="标签属性"
              width="80"
              :visible="showColumnObj.isTag"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.isEdit"
                  v-model="scope.row.isTag"
                  :disabled="scope.row.sourceType === 1"
                ></el-checkbox>
                <span v-else>{{ scope.row.isTag ? '是' : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="非空"
              width="80"
              :visible="showColumnObj.isNullableShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.isEdit"
                  v-model="scope.row.isNullable"
                  @change="isNullchange(scope)"
                  :disabled="scope.row.sourceType === 1"
                ></el-checkbox>
                <span v-else>{{ scope.row.isNullable ? '是' : '' }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="引用属性"
              width="150"
              :visible="showColumnObj.referenceClassAttributeIdShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="scope.row.isEdit"
                  clearable
                  filterable
                  size="small"
                  v-model="scope.row.referenceClassAttributeId"
                  placeholder="请选择"
                  @change="rowReferenceChange(scope)"
                  :disabled="scope.row.sourceType === 1"
                >
                  <el-option
                    v-for="item in referenceList"
                    :key="item.id"
                    :label="item.classNameAttrName"
                    :value="item.id"
                  >
                    <span style="float: left" class="m-r-10">{{ item.className }}</span>
                    <span style="float: right">{{ item.name }}</span>
                  </el-option>
                </el-select>
                <span v-else>{{
                  _.get(
                    _.find(referenceList, { id: scope.row.referenceClassAttributeId }),
                    'classNameAttrName'
                  )
                }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="引用显示属性"
              width="300"
              :visible="showColumnObj.displayReferenceClassAttributeIdShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <el-select
                  v-if="scope.row.isEdit"
                  clearable
                  multiple
                  filterable
                  size="small"
                  v-model="scope.row.displayReferenceClassAttributeName"
                  @change="
                    (val) => {
                      yyxssxChange(scope.row, val)
                    }
                  "
                  placeholder="请选择"
                  :disabled="!scope.row.referenceClassAttributeId"
                >
                  <el-option
                    v-for="item in scope.row.displayReferenceClassAttributeArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span style="float: left" class="m-r-10">{{ item.className }}</span>
                    <span style="float: right">{{ item.name }}</span>
                  </el-option>
                </el-select>
                <span v-else>{{
                  _.get(
                    _.find(scope.row.displayReferenceClassAttributeArr, {
                      id: scope.row.displayReferenceClassAttributeId,
                    }),
                    'name'
                  )
                }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              align="center"
              title="单位"
              width="150"
              :visible="showColumnObj.unitNameShow"
              class-name="cell-center"
              header-class-name="cell-center"
            >
              <template slot-scope="scope">
                <!-- <el-input
                  v-if="scope.row.isEdit"
                  clearable
                  size="mini"
                  v-model="scope.row.unitId"
                  placeholder="请输入内容"
                  :disabled="disabledAll"
                ></el-input>
                <span v-else>{{ scope.row.unitName }}</span> -->
                <el-select
                  size="small"
                  v-model="scope.row.unitId"
                  clearable
                  filterable
                  :disabled="scope.row.sourceType === 1"
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </vxe-table-column>
            <!-- <vxe-table-column align="center"
              title="重要属性"
              width="85"
              v-if="showColumnObj.isImportantShow">
              <template slot-scope="scope">
                <el-checkbox size="mini"
                  v-model="scope.row.isImportant"> </el-checkbox>
              </template>
            </vxe-table-column>-->
            <!-- <vxe-table-column
              align="center"
              title="是否规则属性"
              width="120"
              v-if="showColumnObj.isRuleExpressionShow"
            >
              <template slot-scope="scope">
                <el-checkbox
                  size="mini"
                  v-model="scope.row.isRuleExpression"
                  @change="isRuleExpressionchange(scope)"
                >
                </el-checkbox>
              </template>
            </vxe-table-column>-->
            <!-- <vxe-table-column
              align="center"
              title="规则表达式"
              width="150"
              v-if="showColumnObj.ruleExpressionShow"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="small"
                  v-model="scope.row.ruleExpression"
                  placeholder="请输入内容"
                  :disabled="!scope.row.isRuleExpression"
                >
                </el-input>
              </template>
            </vxe-table-column>-->
            <!-- <vxe-table-column
              align="center"
              title="属性分组"
              width="150"
              v-if="showColumnObj.attributeGroupNameShow"
            >
              <template slot-scope="scope">
                <el-select
                  clearable
                  filterable
                  v-model="scope.row.attributeGroupName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in AttrGroupArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </template>
            </vxe-table-column>-->
          </vxe-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="closeDia">取消</el-button>
        <el-button type="primary" @click="handleClose" :disabled="ifCanSave" :loading="holeLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 控制显示列的对话框 -->

    <el-dialog title="更新实体信息" :visible.sync="attrdiaVis" width="50%" v-dialogDrag>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-input
            class="typesearchinp"
            v-model="classSearchInfo"
            size="small"
            placeholder="请输入类别代码或名称"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <el-button
            type="primary"
            size="small"
            icon="iconfont icon-search"
            @click="askQuickType(classSearchInfo, updTypeObj)"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table
        ref="quickmultipleTable"
        :data="quickTypeData"
        tooltip-effect="dark"
        height="45vh"
        border
        class="mt-10px"
        @selection-change="handlequickselect"
      >
        <el-table-column type="selection" width="175"></el-table-column>
        <el-table-column class="updinftablecol" prop="code" label="类别代码"></el-table-column>
        <el-table-column
          class="updinftablecol"
          prop="name"
          label="类别名称"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div class="mt-10px tr">
        <el-pagination
          @size-change="updTypeSizeChange"
          @current-change="updTypeCurrentChange"
          :current-page="updTypeObj.currPage"
          :page-sizes="updTypeObj.pageSizes"
          :page-size="updTypeObj.pageSize"
          layout="->, total, sizes, prev, pager, next, jumper"
          :total="updTypeObj.sum"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="attrdiaVis = false" size="small" icon="iconfont icon-close"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="handleAttrDiaSave" class="iconfont icon-save"
          >添 加</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="设置关系"
      class="relationDialog"
      :visible.sync="relationDia"
      width="30%"
      v-dialogDrag
    >
      <el-form :model="relationForm" ref="relationForm" :rules="relativeRules" label-width="80px">
        <el-form-item label="关系名称 :" prop="RelationName">
          <el-input v-model="relationForm.RelationName"></el-input>
        </el-form-item>
        <el-form-item label="源对象 :" prop="SourceName">
          <el-input v-model="relationForm.SourceName" disabled></el-input>
        </el-form-item>
        <el-form-item label="目标对象 :" prop="TargetName">
          <el-input v-model="relationForm.TargetName" disabled></el-input>
        </el-form-item>
        <el-form-item label="关系类型 :" prop="RelationType">
          <el-select v-model="relationForm.RelationType" placeholder="请选择关系类型">
            <el-option
              v-for="item in relationTypeArr"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="relationDia = false" icon="iconfont icon-close">取 消</el-button>
        <el-button type="primary" @click="handleEditRelation">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mxStdDrawingService from '@/services/bsApi/mxStdDrawingService'
import StdExtendAttributeMapping from '@/services/bsApi/StdExtendAttributeMapping'
import StdClassService from '@/services/bsApi/StdClassService'
import StdClassAttributeService from '@/services/bsApi/StdClassAttributeService'
import StdClassTypeService from '@/services/bsApi/StdClassTypeService'
import StdClassAttributeGroupService from '@/services/bsApi/StdClassAttributeGroupService'
import StdIdentifierService from '@/services/bsApi/StdIdentifierService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import stdClassListService from '@/services/bsApi/stdClassListService'
import unitMeasureservice from '@/services/unitMeasureservice'
import stdClassLabelService from '@/services/stdClassLabelService'
import MasterDataManageService from '@/services/masterDataManageService'

export default {
  name: 'mxgraph',
  components: {},
  data() {
    return {
      unitList: [],
      tableHeight: '340px',
      updateKey: 1,
      // zh新增---start
      disabledAll: true, // 根据是否选标准属性来动态控制是否可以选
      classFormRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: '请输入符合规则的代码',
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // isMainData: [{ required: true, message: '请选择是否主数据', trigger: 'change' }],
        // isType: [{ required: true, message: '请选择是否是类型', trigger: 'change' }],
      },
      relativeRules: {
        RelationName: [{ required: true, message: '请输入名称', trigger: 'change' }],
        SourceName: [{ required: true, message: '请输入源对象', trigger: 'change' }],
        TargetName: [{ required: true, message: '请输入目标对象', trigger: 'change' }],
        RelationType: [{ required: true, message: '请选择关系类型', trigger: 'change' }],
      },
      typeInfo: {
        id: '',
        standardId: '',
        path: '',
        parentId: '',
        name: '',
        isAbstract: 0,
        classTypeId: '',
        classTypeCode: '',
        description: '',
        remark: '',
        flag: 0,
        seqNo: 0,
        approveStatus: 0,
        classTypeName: '',
        code: '',
        tableName: '',
        classLabelIds: [],
        isMainData: false,
        dataMainTypeId: '',
        isType: false,
        stdClassTypeAttributeCateId: '',
        dynamicColumnData: [],
      }, // 类别信息
      parentTypeList: [],
      typeClassList: [], // 类别类型
      relationLabelList: [],
      // zh新增---end
      showColumnObj: {
        seqNoShow: true,
        nameShow: true,
        attributeCodeShow: true,
        codeShow: true,
        valueTypeShow: true,
        lengthShow: true,
        decimalPointShow: true,
        defaultValueShow: true,
        isPrimaryShow: true,
        isName: true,
        isTag: true,
        isNullableShow: true,
        isImportantShow: false,
        isRuleExpressionShow: false,
        ruleExpressionShow: false,
        referenceClassAttributeIdShow: true,
        displayReferenceClassAttributeIdShow: true,
        className: true,
        className2: true,
        unitNameShow: true,
        attributeGroupNameShow: false,
      },
      thistestwohu: false, // 测试v-if
      relationForm: {
        id: '', // 绘图中的类与类关系的id
        RelationName: '', // 关系名称
        SourceClassId: '', // 源id
        TargetClassId: '', // 目标id
        RelationType: '', // 关系类型
        StandardId: '', // 标准id
        SourceName: '',
        TargetName: '',
      }, // 线关系的表单
      relationTypeArr: [],

      relationDia: false, //  设置关系对话框是否显示
      ifAttrActualColumn: false, // 属性的动态列是否渲染
      referenceList: [],
      holeLoading: false,
      tableLoading: false,
      // secondvalue: {},
      // secondoptions: [],
      attrActualColumnArr: [],
      ifCanSave: false, //    是否能添加属性
      valueTypeOptions: [], //    表格中数据类型选项
      clonemxcell: {},
      //  beforeAdd: '',
      ifTypeDisable: false, //    控制类别信息是否禁用
      ifAttributeDisable: false, //   控制属性信息是否禁用
      cell: {},
      updataType: {},
      innerDiaIf: false, //   是否显示内层嵌套对话框

      typeDes: '', //   嵌套dia中类库描述
      typeStore: {}, //   存储所选择的类库
      // typeStoreOptions: [], //   类库下拉框信息
      updTypeObj: {
        // 快速添加为类的分页器
        currPage: 1, //   更新类当前页面
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        sum: 0,
      },
      typeStorePage: {
        // 快速属性的分页器
        currPage: 1, //   更新类当前页面
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        sum: 0,
      },
      classSearchInfo: '',
      attrdiaVis: false,
      dialogVisible: false,
      activeName: 'type',
      attrData: [], //  类别的属性的表格内容
      //  点击工具栏按钮进入更新类信息
      quickTypeData: [],
      //  双击图像进入更新类信息
      updateTypeInfo: [
        {
          typeStorenum: '1',
          typeStorename: 'Name',
          typeStoredes: '名称',
          datatype: 'String',
        },
        {
          typeStorenum: '2',
          typeStorename: 'Description',
          typeStoredes: '描述',
          datatype: 'String',
        },
      ],
      quickMultipleSelection: {}, //  点击工具栏按钮进入更新类信息
      ywztyList: [], // 业务主题域
      isDisabled: false, // 禁用业务主题域
      standardAttrList: [],
      relationOpr: null, // 设置关系中当前是什么操作
      showPopover: false, // 是否显示筛选列弹窗
      model: [], // 暂时存在的模型数据列表
      lindId: '', // 当前点击设置关系的关系id（mxgraphy自身设置的id)
      editList: [],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      classLabelList: [], // 标签列表
      mainDataTypeList: [], // 主数据类型
      classTypeAttributeList: [], // 类型列表
      standardCode: localStorage.getItem('standardCode'),
      currentClassRowId: '',
    }
  },
  mounted() {
    window.addEventListener('click', this.clickOther)
    window.handleOpen = this.handleOpen
    window.secHandleOpen = this.secHandleOpen
    window.saveDraw = this.saveDraw
    window.afterEdit = this.afterEdit
    window.tellSaveSuccess = this.tellSaveSuccess
    window.openHoleLoading = this.openHoleLoading
    window.closeHoleLoading = this.closeHoleLoading
    window.tellerror = this.tellerror
    window.updateCopyCell = this.updateCopyCell
    window.changeshow = this.changeshow
    window.copyAgain = this.copyAgain
    window.openEditRelation = this.openEditRelation
    window.confirmDeleteEdgeData = this.confirmDeleteEdgeData
    //   this.$nextTick(() => {
    //     this.getStartDraw()
    //   })
  },
  beforeDestroy() {
    // 实例销毁之前对点击事件进行解绑
    window.removeEventListener('click', this.clickOther)
  },
  async created() {
    this.getClassLabelList() // 获取标签
    this.getMainDataType() // 主数据类型
    this.getUnitList() // 获取单位
    this.askValueType() //  获取数值类型
    // this.askTypeInfo() //  获取类别动态信息(新增时的默认动态属性)
    // this.attrActualColumn() //  获取属性动态列
    this.askReferenceClass()
    this.askQuickType(this.classSearchInfo, this.updTypeObj) //  获取快速更新类别信息列表
    this.askAttrGroupArr() // 获取属性分组A
    // zh
    this.getTypeList()
    this.getParentTypeList()
    this.getRelationLabel()
    // this.getClassAttr() // 获取类别动态属性
    // 获取标准属性列表
    this.getStandardAttrList()
    this.getRelationType()
  },
  computed: {
    mxgraphFramePath() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["legacy-resource"].config')
          ?.mxgraphFramePath || '/mxgraph/index.html'
      )
    },
    computedArr() {
      return _.filter(this.attrActualColumnArr, (value) => {
        return value.boo
      })
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  watch: {
    'typeInfo.classTypeId': {
      handler(value) {
        if (value !== '') {
          const target = _.find(this.typeClassList, (o) => {
            return o.id === value
          })
          this.typeInfo.classTypeCode = target ? target.code : ''
        }
      },
      deep: true,
    },
    activeName: {
      async handler(value) {
        if (value === 'attribute') {
          this.askCurrAttr()
        }
      },
    },
    'typeInfo.code': {
      handler(val) {
        if (val) {
          this.typeInfo.tableName = `${this.standardCode}_${this.typeInfo.code}`
        } else {
          this.typeInfo.tableName = ''
        }
      },
    },
  },
  methods: {
    // 是否是类型（是时无法选择类型，且无法选择上级类别）
    changeIsType(val) {
      if (val) {
        this.typeInfo.stdClassTypeAttributeCateId = ''
        this.typeInfo.parentId = ''
      }
    },
    // 是否为主数据(为否时，清空主数据类型)
    changeIsMainData(val) {
      if (!val) {
        this.typeInfo.dataMainTypeId = ''
      }
    },
    // 获取实体标签列表
    async getClassLabelList() {
      const res = await stdClassLabelService.getClassLabelList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (res && res.code === 0) {
        this.classLabelList = res.data
      }
    },
    // 获取主数据类型
    async getMainDataType() {
      const parameter = {
        SkipCount: 1,
        MaxResultCount: 999,
        Sorting: '',
      }
      const res = await MasterDataManageService.getList(parameter)
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.mainDataTypeList = res.data
      } else {
        this.mainDataTypeList = []
      }
    },
    async getUnitList() {
      const parameter = {
        standard_id: this.$route.query.standard_id,
        sort: 'seq_no asc',
      }
      const res = await unitMeasureservice.unitList(parameter)
      if (res && res.code === 0 && res.data) {
        this.unitList = res.data
      }
    },
    // 获取关系类型下拉列表数据
    async getRelationType() {
      const res = await StdClassService.getRelationType()
      if (res && res.code === 0 && res.data) {
        this.relationTypeArr = res.data
      }
    },
    // 获取类别类型列表
    async getTypeList() {
      const parameter = {
        standard_id: this.$route.query.standard_id,
      }
      const res = await StdClassTypeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeClassList = res.data
      }
    },
    // 标准属性代码改变事件
    changeCode(val, objs) {
      if (val) {
        let obj
        this.standardAttrList.forEach((item) => {
          if (item.id === val) {
            obj = item
          }
        })
        objs.code = obj.code
        objs.name = obj.name
        objs.valueType = obj.valueType
        objs.unitId = obj.unitId
        objs.identifierIds = obj.identifierIds
        objs.decimalPoint = obj.decimalPoint
        objs.length = obj.length
        this.disabledAll = false
      }
    },
    // 获取上级类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.$route.query.standard_id,
        data_type: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.parentTypeList = res.data
        this.classTypeAttributeList = _.filter(res.data, (item) => {
          return item.isType && item.approveStatus === 1
        })
      }
    },
    // 获取标准属性下拉列表
    async getStandardAttrList() {
      const parameter = {
        standard_id: this.$route.query.standard_id,
      }
      const res = await stdClassListService.getStandardAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.standardAttrList = res.data
      }
    },
    // 获取关联标识列表
    async getRelationLabel() {
      const parameter = {
        identifier_type: 0,
      }
      const res = await StdIdentifierService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.relationLabelList = res.data
      }
    },
    // 获取类别动态属性
    async getClassAttr() {
      const parameter = {
        data_type: 0,
      }
      const res = await StdExtendAttributeMapping.getLabel(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeInfo.dynamicColumnData = res.data
      }
    },
    clickOther(event) {
      if (
        event &&
        event.srcElement &&
        event.srcElement.className === 'iconfont icon-bg-fullscreen'
      ) {
        if (this.tableHeight === '500px') {
          this.tableHeight = '780px'
        } else {
          this.tableHeight = '500px'
        }
      }
    },
    async actionFocus(obj) {
      if (!obj.referrerId) {
        return
      }
      const parameter = {
        classId: obj.referrerId,
      }
      const res = await stdClassDataService.dict(parameter)
      if (res && res.code === 0 && res.data) {
        this.attrData.forEach((item) => {
          item.dynamicColumnData.forEach((it) => {
            if (obj.id === it.id) {
              this.$set(it, 'actionArr', res.data)
            }
          })
        })
      }
    },
    actionChange(row, obj, val) {
      if (obj.actualAttributeColumnName === '继承属性') {
        if (obj.refValue === '') {
          row.inheritClassName = ''
          obj.value = ''
        } else {
          row.inheritClassName = row.quoteClassName
        }
      }
      obj.value = val
    },

    // 拿到属性分组的数据
    async askAttrGroupArr() {
      const query = {
        // standard_id: this.$route.query.standard_id,
      }
      const res = await StdClassAttributeGroupService.list(query)
      if (res && res.code === 0 && res.data) {
        this.AttrGroupArr = res.data
      }
    },
    //  是否规则属性变化
    isRuleExpressionchange(scope) {
      if (scope.row.isRuleExpression === true) {
        scope.row.ifRuleExpression = false
      } else {
        scope.row.ifRuleExpression = true
      }
    },
    //  打开设置关系对话框(点击连线)
    async openEditRelation(e, d) {
      // if (!e.children) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选保存绘图',
      //   })
      //   return
      // }
      // 清空之前的数据
      if (e.prType === 3) {
        const res = await StdClassService.getRelation({
          id: e.dataId,
        })
        if (res.code === 0 && res.data) {
          this.relationForm.RelationType = res.data.relationType
        }
        this.relationForm.id = e.dataId
        this.relationForm.RelationName = e.value
        this.relationOpr = 'update'
      } else {
        this.relationOpr = 'add'
        this.relationForm.RelationName = ''
        this.relationForm.id = ''
        this.relationForm.RelationType = ''
      }
      this.relationForm.SourceName = e.source.dataId ? e.source.value : e.source.parent.value
      this.relationForm.TargetName = e.target.dataId ? e.target.value : e.target.parent.value
      if (_.isEmpty(this.relationForm.SourceName) || _.isEmpty(this.relationForm.TargetName)) {
        this.$message.warning('请先保存源对象或目标对象的类别')
        return
      }
      this.relationForm.SourceClassId = e.source.dataId ? e.source.dataId : e.source.parent.dataId
      this.relationForm.TargetClassId = e.target.dataId ? e.target.dataId : e.target.parent.dataId
      this.relationForm.StandardId = this.$route.query.standard_id
      this.relationDia = true
      this.lindId = e.id
    },
    //  设置线的关系后的确定操作
    async handleEditRelation() {
      this.$refs.relationForm.validate(async (valid) => {
        if (valid) {
          const params = _.cloneDeep(this.relationForm)
          delete params.SourceName
          delete params.TargetName
          const result = {}
          if (this.relationOpr === 'update') {
            _.assign(
              result,
              await StdClassService.updateRelation({
                Model: params,
                UpdateColumns: [],
                NoRepeatNames: [],
              })
            )
          } else {
            _.assign(
              result,
              await StdClassService.addRelation({
                Model: params,
                UpdateColumns: [],
                NoRepeatNames: [],
              })
            )
          }
          if (result && result.code === 0) {
            const cell =
              _.head(this.$refs.mxgraphframe.contentWindow.findCellById(this.lindId)) || {}
            if (cell) {
              cell.prType = 3
              cell.dataId = result.data.id
              cell.value = result.data.relationName
            }
            this.$refs.mxgraphframe.contentWindow.Graph.prototype.addsavetoolbtn()
            // _.forEach(this.model, (val) => {
            //   if (val.id === this.lindId) {
            //     val.prType = 3
            //     val.dataId = result.data.id
            //     val.value = result.data.relationName
            //     return false
            //   }
            // })
            // const data = {
            //   model: {
            //     id: this.$route.query.id,
            //     standardId: this.$route.query.standard_id,
            //     graphModel: this.model,
            //   },
            //   updateColumns: [],
            //   noRepeatNames: '',
            // }
            // this.saveCavan(data) // 重新绘制绘图
            this.relationDia = false
          }
        }
      })
    },
    closeDia() {
      this.ifAttrActualColumn = false
      this.dialogVisible = false
    },
    async askQuickType(searchInfo, pageinfo) {
      const query = {
        standard_id: this.$route.query.standard_id,
        data_type: 1,
        // is_dict: 0,
        keyword: searchInfo,
        pageno: pageinfo.currPage,
        pagesize: pageinfo.pageSize,
      }
      const res = await StdClassService.list(query)
      if (res && res.code === 0 && res.data) {
        this.quickTypeData = res.data
        this.updTypeObj.sum = res.page.recordCount
      }
    },
    refreshColumn() {
      this.showPopover = false
      this.attrLoading = true
      setTimeout(() => {
        this.$refs.table.refreshColumn()
        this.attrLoading = false
      })
    },
    updateCopyCell(data) {
      this.attrData = data
    },
    async rowReferenceChange(data) {
      data.row.displayReferenceClassAttributeName = ''
      if (data.row.referenceClassAttributeId === '') {
        data.row.length = 1
        data.row.iflength = false
        data.row.ifvalueType = false
      } else {
        data.row.length = 36
        data.row.iflength = true
        data.row.ifvalueType = true
        const parameter = {
          classId: '',
        }
        this.referenceList.forEach((item) => {
          if (item.id === data.row.referenceClassAttributeId) {
            parameter.classId = item.classId
          }
        })
        const res = await stdClassDataService.inherit(parameter)
        if (res && res.code === 0 && res.data) {
          res.data.items.forEach((item) => {
            this.$set(item, 'value', item.id)
          })
          this.$set(data.row, 'displayReferenceClassAttributeArr', res.data.items)
        }
      }
    },
    scopeSelectChange(scope) {
      //   编辑属性中，数值类型改变发生的校验
      const index = scope.row.valueType
      scope.row.length = 1
      scope.row.iflength = true
      scope.row.ifdecimalPoint = true

      if (index === 1) {
        scope.row.iflength = false
        scope.row.length = 1
        scope.row.ifdecimalPoint = true
      }
      if (index === 2) {
        scope.row.iflength = true
        scope.row.length = 0
        scope.row.ifdecimalPoint = true
      }
      if (index === 3) {
        scope.row.iflength = true
        scope.row.ifdecimalPoint = false
      }
      if (index === 4) {
        scope.row.iflength = true
        scope.row.ifdecimalPoint = true
      }
      if (index === 5) {
        scope.row.length = 36
        scope.row.ifdecimalPoint = true
      }
      if (index === 6) {
        scope.row.iflength = true
        scope.row.ifdecimalPoint = true
      }
      if (index === 7) {
        scope.row.iflength = true
        scope.row.ifdecimalPoint = true
      }
      if (index === 8) {
        scope.row.iflength = true
        scope.row.ifdecimalPoint = true
      }
    },
    async askReferenceClass() {
      //  拿到引用属性的选项
      const query = {
        is_primary: true,
        standard_id: this.$route.query.standard_id,
        // is_dict: 0,
      }
      const res = await StdClassAttributeService.list(query)
      if (res && res.code === 0 && res.data) {
        this.referenceList = res.data
      }
    },
    async attrActualColumn() {
      //  拿到属性中的动态列
      const query = {
        data_type: 1,
      }
      const res = await StdExtendAttributeMapping.getLabel(query)
      if (res && res.code === 0 && res.data) {
        this.attrActualColumnArr = res.data
        _.forEach(this.attrActualColumnArr, (value) => {
          this.$set(value, 'boo', false)
          if (
            value.actualAttributeColumnName === '英文名称' ||
            value.actualAttributeColumnName === '继承属性' ||
            value.actualAttributeColumnName === '唯一性要求'
          ) {
            value.boo = true
          }
        })
      }
    },
    async askValueType() {
      const res = await StdClassAttributeService.getValueType()
      if (res && res.code === 0 && res.data) {
        this.valueTypeOptions = res.data
      }
    },
    backToDrawList() {
      this.$router.push({
        path: `${this.basePath}/standardManage/drawlist`,
      })
    },
    isprimarychange(scope) {
      if (scope.row.isPrimary === true) {
        _.forEach(this.attrData, (value) => {
          value.isPrimary = false
          // value.isNullable = false
          value.ifReference = false
        })
        scope.row.isPrimary = true
        scope.row.isNullable = true
        scope.row.ifReference = true
      } else {
        scope.row.ifReference = false
      }
    }, //  根属性变化
    isNullchange(scope) {
      if (scope.row.isPrimary === true) {
        scope.row.isNullable = true
      }
    },
    checkData(data) {
      const row = data.row
      const column = data.column
      if (column.label === '代码') {
        const standard = /^(?!(\d)+$)[\w]+$/
        if (!standard.test(row.code) && row.code !== '') {
          this.$message.error('请输入正确格式的代码')
          this.ifCanSave = true
        } else {
          this.ifCanSave = false
        }
      } else if (column.label === '序号') {
        const standard = /^[1-9][0-9]*$/
        if (!standard.test(row.seqNo) && row.seqNo !== '') {
          this.$message.error('请输入正确格式的序号')
          this.ifCanSave = true
        } else {
          this.ifCanSave = false
        }
      } else if (column.label === '精度') {
        const standard = /^[1-9][0-9]*$/
        if (!standard.test(row.decimalPoint) && row.decimalPoint !== '') {
          this.$message.error('请输入正确格式的精度')
          this.ifCanSave = true
        } else {
          this.ifCanSave = false
        }
      }
    },
    async searchTypeDetail() {
      //  根据类库id搜索所有属性
      const query = {
        class_id: this.typeStore,
        pageno: this.typeStorePage.currPage,
        pagesize: this.typeStorePage.pageSize,
        keyword: this.typeDes,
      }
      const res = await StdClassAttributeService.list(query)
      if (res && res.code === 0 && res.data) {
        this.updateTypeInfo = res.data
        this.typeStorePage.sum = res.page.recordCount
      } else {
        this.$message.error('搜索失败')
      }
    },
    confirmDeleteEdgeData(data) {
      this.$confirm('是否要删除设置的关系数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await StdClassService.removeRelation({
          data: [data[0].dataId],
        })
        if (res && res.code === 0) {
          this.$message.success(res.msg)
          this.$refs.mxgraphframe.contentWindow.removeCell(data[0].dataId)
          this.$refs.mxgraphframe.contentWindow.Graph.prototype.addsavetoolbtn()
          // const deleteEdgModel = _.find(this.model, ['dataId', data[0].dataId])
          // const graphModel = _.difference(this.model, [deleteEdgModel])
          // const param = {
          //   model: {
          //     id: this.$route.query.id,
          //     standardId: this.$route.query.standard_id,
          //     graphModel,
          //   },
          //   updateColumns: [],
          //   noRepeatNames: '',
          // }
          // this.saveCavan(param) // 重新绘制绘图
        }
      })
    },
    async deleteRow() {
      const list = this.$refs.table.getCheckboxRecords()
      const notDeleteList = _.filter(list, (item) => {
        return item.sourceType === 1
      })
      if (notDeleteList.length > 0) {
        this.$message.warning('对象的类型属性不能删除！')
        return
      }
      if (!_.isEmpty(list)) {
        this.holeLoading = true
        const ids = _.compact(_.map(list, 'id'))
        // 如果勾选列有新增未保存的行
        const newRows = _.compact(
          _.map(list, (item) => {
            return !item.id ? item.seqNo : null
          })
        )
        if (!_.isEmpty(newRows)) {
          this.attrData = _.filter(this.attrData, (item) => {
            return !_.includes(newRows, item.seqNo)
          })
        }
        // 勾选的列都是新增未保存的
        if (_.isEmpty(ids)) {
          this.holeLoading = false
          return
        }
        const res = await StdClassAttributeService.remove({
          data: ids,
        })
        if (res && res.code === 0) {
          this.$refs.mxgraphframe.contentWindow.Graph.prototype.deleteattr_confirm(this.cell, ids)
          this.attrData = _.filter(this.attrData, (item) => {
            return !_.includes(ids, item.id)
          })
          // 重新排序
          _.forEach(this.attrData, (el, index) => {
            el.seqNo = index + 1
          })
        }
        this.holeLoading = false
      } else {
        this.$message.error('请先选择要删除的项')
        return null
      }
      this.$refs.mxgraphframe.contentWindow.Graph.prototype.addsavetoolbtn()
      return true
    },
    //  处理更新实体信息中的勾选
    handlequickselect(val) {
      if (val.length > 1) {
        this.$refs.quickmultipleTable.clearSelection()
        this.$refs.quickmultipleTable.toggleRowSelection(val.pop())
      } else {
        this.quickMultipleSelection = val.pop()
      }
    },
    //  拿到动态的类别信息（如来源数据表等等,新增操作时）
    async askTypeInfo() {
      const query = {
        data_type: 0,
      }
      const res = await StdExtendAttributeMapping.getLabel(query)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return null
    },
    //  拿到当前cell的属性
    async askCurrAttr() {
      this.tableLoading = true
      const query = {
        class_id: this.cell.dataId,
      }
      const res = await StdClassAttributeService.list(query)
      if (res && res.data) {
        this.attrData = res.data
        // 反显动态列表值
        // if (this.attrData.length) {
        //   this.attrData[0].dynamicColumnData.forEach((item) => {
        //     if (item.referrerId) {
        //       this.actionFocus(item)
        //     }
        //   })
        // }
        _.forEach(this.attrData, async (it) => {
          it.isEdit = true
          if (it.displayReferenceClassAttributeId) {
            it.displayReferenceClassAttributeId = it.displayReferenceClassAttributeId.split(',')
          }
          if (it.displayReferenceClassAttributeName) {
            it.displayReferenceClassAttributeName = it.displayReferenceClassAttributeName.split(',')
          }
          if (it.referenceClassAttributeId) {
            const parameter = {
              classId: '',
            }
            this.referenceList.forEach(async (item) => {
              if (item.id === it.referenceClassAttributeId) {
                parameter.classId = item.classId
                it.quoteClassName = item.classNameAttrName.split('.')[0]
              }
            })
            // 防止引用实体根属性已经改变，在引用属性列表里找不到对应id导致报错
            if (!parameter.classId) {
              it.referenceClassAttributeId = ''
            }
            // 请求反显继承属性的列表
            // const resInfo = await stdClassDataService.inherit(parameter)
            // if (resInfo && resInfo.code === 0 && resInfo.data) {
            //   it.dynamicColumnData.forEach((item) => {
            //     // 继承属性
            //     if (item.actualAttributeColumnName === '继承属性') {
            //       this.$set(item, 'actionArr', resInfo.data.items)
            //     }
            //     if (item.actualAttributeColumnName === '继承属性' && item.value) {
            //       it.inheritClassName = it.quoteClassName
            //     }
            //   })
            // }
          }
        })
        this.ifAttrActualColumn = true
        if (res.data.length === 0) {
          this.addRow()
        }
      }
      this.tableLoading = false
    },
    //   双击图形打开对话框
    async handleOpen(clickcell, way) {
      const cell = clickcell
      if (cell.dataId !== '') {
        //  如果dataid不为空，发送请求向服务器拿类别信息
        const query = {
          data_type: 1,
          id: cell.dataId,
        }
        const res = await StdClassService.detail(query)
        this.typeInfo = res.data
        this.typeInfo.isMainData = this.typeInfo.isMainData === 1
        this.currentClassRowId = cell.dataId
        if (_.isNil(this.typeInfo)) {
          this.$message.warning('该类别已被删除')
          return
        }
        // 编辑类时先获取业务主题域列表
        // this.typeInfo.dynamicColumnData.forEach((item) => {
        //   if (item.actualAttributeColumnName === '业务主题域') {
        // this.ywztyFocus(item)
        //   }
        // })
      } else {
        //  如果dataid为空，说明是新增，直接给typeinfo赋空值
        this.typeInfo = {
          id: '',
          standardId: '',
          path: '',
          parentId: '',
          name: '',
          isAbstract: 0,
          classTypeId: '',
          classTypeCode: '',
          description: '',
          remark: '',
          flag: 0,
          seqNo: 0,
          approveStatus: 0,
          classTypeName: '',
          code: '',
          tableName: '',
          dynamicColumnData: [],
        }
        // this.typeInfo.dynamicColumnData = await this.askTypeInfo()
        this.typeInfo.standardId = this.$route.query.standard_id
      }
      this.cell = cell
      if (way && way === 'attribute') {
        this.activeName = 'attribute'
        this.askCurrAttr()
      } else {
        this.activeName = 'type'
      }
      this.dialogVisible = true //  打开dialog
      if (cell.prType === 1) {
        this.ifAttributeDisable = false // 不禁用属性设置
        this.isDisabled = true
      } else if (cell.prType === 0) {
        this.ifAttributeDisable = true //  禁用属性设置
        this.isDisabled = false
      }
    },
    // compare(property) {
    //   return function(a, b) {
    //     let value1 = a[property]
    //     let value2 = b[property]
    //     return value1 - value2
    //   }
    // },
    //   保存操作时，关闭双击打开的对话框
    rowClick({ row, rowIndex }) {
      row.isEdit = true
      Vue.set(this.attrData, rowIndex, row)
      this.editList.push(row.id)
    },
    async handleClose() {
      this.$refs.typeInfo.validate(async (valid) => {
        if (valid) {
          this.holeLoading = true
          let flag = true
          _.forEach(this.typeInfo.dynamicColumnData, (item) => {
            if (
              item.actualAttributeColumnName === '英文名称' &&
              (item.value === null || item.value === '')
            ) {
              this.$message({
                type: 'warning',
                message: '请填写英文名称',
              })
              flag = false
            }
          })
          if (!flag) {
            this.holeLoading = false
            return
          }
          if (this.activeName === 'type') {
            if (this.typeInfo.id !== '') {
              // 通过id是否存在，来判断新增还是编辑
              this.typeInfo.children = []
              this.typeInfo.identifierIds = []
            }
            const query = {
              //  创建请求的query
              model: this.typeInfo,
              updateColumns: [],
              noRepeatNames: '',
            }
            query.model.isMainData = query.model.isMainData ? 1 : 0
            query.model.standardCode = this.standardCode
            let res = {}
            if (this.typeInfo.id === '') {
              //  如果id为空，就是create
              res = await StdClassService.create(query)
            } else {
              //  如果id不为空，就是update
              res = await StdClassService.update(query)
            }

            if (res && res.code === 0 && res.data) {
              //   如果res存在，就去编辑画布中的cell
              if (res.data.parentId === '00000000-0000-0000-0000-000000000000') {
                // 没有设置上级类别就置空，不然保存的时候会给上级类别设置这个00
                res.data.parentId = ''
              }
              this.typeInfo = res.data
              // let colorList = []
              // const result = await axios.get('./static/entityTypeColor.json')
              // if (result && result.data) {
              //   colorList = result.data[this.currentEnv.VUE_APP_CURRENT_PROJECT]
              // }
              this.$nextTick(() => {
                this.$refs.mxgraphframe.contentWindow.Graph.prototype.edittypeInfo(
                  this.cell,
                  this.typeInfo
                  // colorList
                )
                this.ifAttributeDisable = false
                this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope.refresh()
                this.holeLoading = false
                this.dialogVisible = false
              })
            } else {
              this.$message.error('保存出错')
              this.holeLoading = false
              return
            }
          } else if (this.activeName === 'attribute') {
            //  先验证属性信息是否完整
            let flagInfo = true
            _.forEach(this.attrData, (value, index) => {
              //  给第二个孩子的prtype赋值
              const currcell = value
              currcell.prType = 2
              if (currcell.name === '') {
                this.$message.error(`第${index + 1}行,中文名称不能为空`)
                flagInfo = false
                return false
              }
              if (currcell.code === '') {
                this.$message.error(`第${index + 1}行,代码不能为空`)
                flagInfo = false
                return false
              }
            })
            if (!flagInfo) {
              this.holeLoading = false
              return
            }
            // 只保存修改过的数据
            const data = _.cloneDeep(
              _.filter(this.attrData, (item) => {
                return _.includes(this.editList, item.id) || !item.id
              })
            )
            data.forEach((item) => {
              if (item.displayReferenceClassAttributeId) {
                item.displayReferenceClassAttributeId = item.displayReferenceClassAttributeId.join(
                  ','
                )
              }
              if (item.displayReferenceClassAttributeName) {
                item.displayReferenceClassAttributeName = item.displayReferenceClassAttributeName.join(
                  ','
                )
              }
            })
            if (_.isEmpty(data)) {
              this.holeLoading = false
              this.$message.warning('未修改数据')
              return
            }
            const res = await StdClassAttributeService.editattribute(data)
            if (res && res.data && res.data.length) {
              this.editList = []
              // this.attrData = res.data
              _.forEach(this.attrData, (value) => {
                value.iflength = false
                value.ifReference = false
                value.ifRuleExpression = true
                value.ifdecimalPoint = true
              })
              // this.attrData.sort(this.compare('seqNo'))
              //  调用graph.js中的添加属性方法
              this.$refs.mxgraphframe.contentWindow.Graph.prototype.addnewattr(
                this.currentEnv.VUE_APP_CURRENT_PROJECT,
                this.cell,
                res.data
              )
            } else {
              this.holeLoading = false
              return
            }
            this.holeLoading = false
            this.dialogVisible = false
            this.askCurrAttr()
          }
          this.askReferenceClass()
          this.$nextTick(() => {
            this.$refs.mxgraphframe.contentWindow.Graph.prototype.addsavetoolbtn()
          })
        }
      })
    },
    //   点击工具栏打开对话框
    async secHandleOpen(cell) {
      this.cell = cell
      this.attrdiaVis = true
      this.askQuickType(this.classSearchInfo, this.updTypeObj)
    },
    //   关闭点击工具栏打开的对话框
    async handleAttrDiaSave() {
      this.holeLoading = true
      //  验证当前画布会不会重复code
      const extcode = []
      const holearr = this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope.getModel()
        .root.children[0].children
      _.forEach(holearr, (value) => {
        value.dataId = value.dataId ? value.dataId : ''
        extcode.push(value.dataId)
      })
      const savecell = this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope
        .getModel()
        .getCell(this.cell[0].id) // 获取单元格，返回指定id的单元格
      if (
        this.quickMultipleSelection &&
        !_.includes(extcode, this.quickMultipleSelection.id) &&
        this.cell[0].prType === 0 &&
        this.quickMultipleSelection.id
      ) {
        //  发请求拿到该类别的所有属性
        const query = {
          class_id: this.quickMultipleSelection.id,
        }
        const res = await StdClassAttributeService.list(query)
        if (res && res.code === 0 && res.data) {
          this.$refs.mxgraphframe.contentWindow.Graph.prototype.quickaddnewattr(
            this.currentEnv.VUE_APP_CURRENT_PROJECT,
            savecell,
            res.data,
            this.quickMultipleSelection
          )
          this.$refs.mxgraphframe.contentWindow.Graph.prototype.addsavetoolbtn()
          this.attrdiaVis = false
        }
      } else if (this.cell[0].prType === 1) {
        this.$message.error('已经是实体了')
        this.holeLoading = false
      } else if (
        this.quickMultipleSelection &&
        _.includes(extcode, this.quickMultipleSelection.id)
      ) {
        this.$message.error('该类别已存在')
        this.holeLoading = false
      } else if (!this.quickMultipleSelection || !this.quickMultipleSelection.id) {
        this.$message.error('请选择一个实体')
        this.holeLoading = false
      }
    },
    tellSaveSuccess() {
      this.$message.success('保存成功')
    },
    //   更新类别分页器一页显示多少数据改变
    updTypeSizeChange(val) {
      this.updTypeObj.pageSize = val
      this.askQuickType(this.classSearchInfo, this.updTypeObj)
    },
    //   更新类别分页器改变
    updTypeCurrentChange(val) {
      this.updTypeObj.currPage = val
      this.askQuickType(this.classSearchInfo, this.updTypeObj)
    },
    //   类库分页器一页显示多少数据改变
    typeStoreSizeChange(val) {
      this.typeStorePage.pageSize = val
      this.searchTypeDetail()
    },
    //   类库分页器改变
    typeStoreCurrentChange(val) {
      this.typeStorePage.currPage = val
      this.searchTypeDetail()
    },
    async getStartDraw() {
      //  从后台拿到数据重新渲染
      this.holeLoading = true
      const query = {
        id: this.$route.query.id,
      }
      const res = await mxStdDrawingService.getstartcavans(query)
      if (res && res.code === 0 && res.data.content) {
        const graphModel = JSON.parse(res.data.content)
        this.$refs.mxgraphframe.contentWindow.initdraw(
          graphModel,
          _.isArray(graphModel) ? 'mxCell' : 'xml'
        )
        // zh测试
        // this.model = res.data.graphModel
        this.$refs.mxgraphframe.contentWindow.mxGraph.prototype.center()
        this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope.zoomTo(1)
        this.holeLoading = false
      } else {
        this.holeLoading = false
      }
    },
    openHoleLoading() {
      //  打开遮罩层
      this.holeLoading = true
    },
    closeHoleLoading() {
      //  关闭遮罩层
      this.holeLoading = false
    },
    tellerror(msg) {
      //  通知错误
      this.$message.error(msg)
    },
    copyAgain(newcell) {
      this.cell = newcell
      if (newcell && newcell.classData) {
        this.typeInfo = newcell.classData
      }
      if (newcell && newcell.children && newcell.children.length > 0) {
        this.attrData = _.cloneDeep(newcell.children)
      }
    },
    async saveDraw(data) {
      if (data.graphModel === null) {
        data.graphModel = []
      }
      data.model.id = this.$route.query.id
      data.model.standardId = this.$route.query.standard_id
      this.saveCavan(data)
    },
    async saveCavan(data) {
      const res = await mxStdDrawingService.savecavans(data)
      if (res && res.code === 0 && res.data) {
        // zh测试
        this.model = res.data.graphModel
        this.$message.success('保存成功')
        this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope.getModel().clear() // 使用createRoot设置新根
        this.getStartDraw()
        this.holeLoading = false
        this.askReferenceClass()
        return res
      }
      this.$message.error('保存失败')
      this.$refs.mxgraphframe.contentWindow.Graph.prototype.savescope.getModel().clear()
      this.getStartDraw()
      this.holeLoading = false
      return null
    },
    async addRow(quickvalue) {
      const seqarr = []
      _.forEach(this.attrData, (value) => {
        seqarr.push(value.seqNo)
      })
      seqarr.sort((a, b) => {
        return b - a
      })
      if (!quickvalue) {
        // let flag = true
        // this.attrData.forEach((item, index) => {
        //   if (item.id === '') {
        //     flag = false
        //     this.$message({
        //       message: `第${index + 1}条为空数据，请填写保存后再添加`,
        //       type: 'warning',
        //     })
        //   }
        // })
        // if (!flag) {
        //   return
        // }
        const newrow = {
          isEdit: true,
          cascadedClassAttributeId: '',
          cascadedClassAttributeCode: '',
          id: '',
          code: '',
          name: '',
          classId: this.cell.dataId,
          classAttributeGroupId: '',
          attributeId: '',
          flag: 0,
          defaultValue: '',
          inherentClassAttributeId: '',
          isNullable: false,
          isImportant: false,
          isRuleExpression: false,
          isPrimary: false,
          unitId: '',
          referenceClassAttributeId: '',
          referenceClassAttribute: '',
          referenceClassAttributelabel: '',
          ruleExpression: '',
          columnName: '',
          attributeGroupName: '',
          groupConcatIdentifierNames: '',
          groupConcatIdentifierIds: '',
          remark: '',
          standardId: this.$route.query.standard_id,
          ifvalueType: false,
          valueType: 1,
          decimalPoint: 0,
          seqNo: 1,
          length: 1,
          iflength: false,
          ifReference: false,
          ifRuleExpression: true,
          ifdecimalPoint: true,
          dynamicColumnData: [],
          seen: true,
          selectReferenceClassAttributeIdList: [],
          displayReferenceClassAttributeId: '',
          displayReferenceClassAttributeName: '',
        }
        // 获取编码反显code
        // if (this.attrData.length !== 0) {
        //   const obj = [...this.attrData].pop()
        //   if (obj.code) {
        //     const str = obj.code.substring(obj.code.length - 2)
        //     const prefix = obj.code.substring(0, obj.code.length - 2)
        //     newrow.code = `${prefix}${this.getMaximum(str)}`
        //   }
        // }
        newrow.dynamicColumnData = _.cloneDeep(this.attrActualColumnArr)
        newrow.seqNo = this.attrData[this.attrData.length - 1] ? seqarr[0] + 1 : 1
        this.attrData.push(newrow)
      } else if (quickvalue && this.attrData[0].code === '' && this.attrData.length === 1) {
        this.attrData.splice(0, 1)
        quickvalue.seqNo = 1
        this.attrData.push(quickvalue)
      } else if (quickvalue) {
        quickvalue.seqNo = seqarr[0] + 1
        this.attrData.push(quickvalue)
      }
    }, //  添加一行
    // getMaximum(number) {
    //   const maxTotal = 99 // 数字编码最大值
    //   const maxNumber = 9 // 前缀数字最大值
    //   const endLetter = 90 // 字母ASCII结束
    //   const startLetter = 65 // 字母ASCII开始
    //   number = number.toUpperCase()
    //   if (number.length !== 2) {
    //     this.$message({
    //       type: 'warning',
    //       message: '编码长度必须是两位',
    //     })
    //     return
    //   }
    //   const isNumber = /^(0|[0-9]*)$/.test(number)
    //   if (isNumber) {
    //     const digital = number - 0
    //     if (digital < maxTotal) {
    //       const ma = (digital + 1).toString()
    //       return ma.length < 2 ? `0${ma}` : ma
    //     }
    //     if (digital === maxTotal) {
    //       return '1A'
    //     }
    //   }
    //   let maximum = ''
    //   const items = number.split('')
    //   const first = items[0] - 0
    //   const second = items[1].charCodeAt()
    //   if (first >= maxNumber && second < endLetter) {
    //     // 数字用完+字母未用完
    //     maximum = first.toString() + String.fromCharCode(second + 1)
    //   } else if (first < maxNumber && second >= endLetter) {
    //     // 数字未用完+字母用完
    //     maximum = (first + 1).toString() + String.fromCharCode(startLetter)
    //   } else if (first < maxNumber && second < endLetter) {
    //     // 数字未用完+字母未用完
    //     maximum = first.toString() + String.fromCharCode(second + 1)
    //   } else if (first >= maxNumber && second >= endLetter) {
    //     // 数字用完+字母用完
    //     this.$message({
    //       type: 'warning',
    //       message: '编码数量已使用完',
    //     })
    //     return
    //   }
    //   return maximum
    // },
    afterEdit(savedcell) {
      this.cell = savedcell
    }, //  拿到修改过后的cell
    // 获取业务主题域列表
    async ywztyFocus(item) {
      const parameter = {
        classId: item.referrerId,
        // attrId: item.id,
      }
      const res = await stdClassDataService.dict(parameter)
      if (res && res.code === 0 && res.data) {
        // this.ywztyList = res.data
        this.typeInfo.dynamicColumnData.forEach((it, index) => {
          if (item.id === it.id) {
            this.$set(this.typeInfo.dynamicColumnData[index], 'actionArr', res.data)
          }
        })
      }
    },
    // 提示重名
    blurZwmc(row) {
      const arr = this.attrData.filter((it) => {
        return row.code !== it.code
      })
      _.forEach(arr, (item) => {
        if (row.name === item.name) {
          this.$message.warning('该实体已有相同中文名称属性！')
          return false
        }
      })
    },
    yyxssxChange(row, val) {
      if (row.displayReferenceClassAttributeArr && row.displayReferenceClassAttributeArr.length) {
        this.$set(row, 'displayReferenceClassAttributeId', val)
      }
    },
  },
}
</script>
<style lang="scss" scpoed>

/deep/.el-tabs__content {
  height: 590px !important;
}
.el-form-item__label {
  text-align: right !important;
}
.el-dialog__body {
  padding: 20px 30px !important;
}
.mxgrapgTopBtn {
  position: absolute;
  right: 2%;
  top: 11%;
}
// .el-select {
//   width: 100%;
// }
.vxe-body--column {
  line-height: 48px !important;
}

</style>
